import { render } from "./TokenAuthView.vue?vue&type=template&id=2481e42b&scoped=true"
import script from "./TokenAuthView.vue?vue&type=script&lang=js"
export * from "./TokenAuthView.vue?vue&type=script&lang=js"

import "./TokenAuthView.vue?vue&type=style&index=0&id=2481e42b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2481e42b"]])

export default __exports__